@if (route()) {
<a [routerLink]="route()!" routerLinkActive="text-primary" [routerLinkActiveOptions]="{ exact: false }"
  class="flex items-center py-3 text-nowrap hover:bg-surface rounded-lg transition-colors focus:outline-none focus:ring-0"
  [class.justify-center]="collapsed()"
  [class.px-4]="!collapsed()"
  [class.px-2]="collapsed()"
  [attr.aria-label]="label()" [attr.aria-current]="active() ? 'page' : null">
  @if (hugeIcon()) {
  <hugeicons-icon class="flex-shrink-0" [class.mr-2]="!collapsed()" [icon]="hugeIcon()!" [size]="20"
    [color]="active() ? 'currentColor' : 'currentColor'" [strokeWidth]="active() ? 1.5 : 1.5">
  </hugeicons-icon>
  <!-- <hugeicons-icon class="mr-3 flex-shrink-0" [icon]="hugeIcon()" [size]="20" color="currentColor"></hugeicons-icon> -->
  } @else if (icon()) {
  <span [innerHTML]="icon()" class="text-xl" [class.mr-3]="!collapsed()" [class.text-primary]="active()"></span>
  }
  @if (!collapsed()) {
  <span>{{ label() }}</span>
  }
</a>
} @else {
<div class="flex items-center py-3 text-text-strong rounded-lg"
  [class.justify-center]="collapsed()"
  [class.px-4]="!collapsed()"
  [class.px-2]="collapsed()"
  [class.bg-primary-soft]="active()"
  [class.text-primary]="active()"
  [class.font-semibold]="active()"
  [attr.aria-label]="label()">
  @if (hugeIcon()) {
  <hugeicons-icon class="flex-shrink-0" [class.mr-3]="!collapsed()" [icon]="hugeIcon()!" [size]="20"
    [color]="active() ? 'currentColor' : 'currentColor'" [strokeWidth]="active() ? 1.5 : 1.5">
  </hugeicons-icon>
  <!-- <hugeicons-icon class="mr-3 flex-shrink-0" [icon]="hugeIcon()" [size]="20" color="currentColor"></hugeicons-icon> -->
  } @else if (icon()) {
  <span [innerHTML]="icon()" class="text-xl" [class.mr-2]="!collapsed()" [class.text-primary]="active()"></span>
  }
  @if (!collapsed()) {
  <span>{{ label() }}</span>
  }
</div>
}